import { empApi } from "./client";

// =============================================================
// API Quản lý CCMG (góc nhìn quản lý) - FEv1 cổng nhân viên.
// Danh sách nhân viên cấp dưới + 4 chỉ số CCMG. Phạm vi do BE lọc theo token.
// Chi tiết tạm giữ/giải ngân tái dùng getBdcPeriodListApi/getBdcDisbursementListApi
// (finance.bdc.api.js) với employeeId của nhân viên được chọn.
// =============================================================

// Danh sách nhân viên cấp dưới kèm chỉ số CCMG -> { items, pagination }
export const getBdcManagerEmployeesApi = (params) =>
  empApi.get("/brokerDebtCertificate/app/manager/employees", params);
